import React, { createContext, useContext, useState, useEffect } from 'react';
import { msalInstance, loginRequest } from 'authConfig.js';

const ClientContext = createContext();

export const ClientProvider = ({ children }) => {
  const [client, setClient] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null)
  const [selectedClientName, setSelectedClientName] = useState("")

  useEffect(() => {
    const getToken = async () => {
      try {
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length === 0) {
          throw new Error('No accounts available');
        }

        const response = await msalInstance.acquireTokenSilent({
          scopes: loginRequest.scopes,
          account: accounts[0],
        });

        const definedUserRole = response?.idTokenClaims?.extension_ClientId;

        definedUserRole === 0 ? setClient(0) : setClient(definedUserRole)
        definedUserRole === 0 ? setSelectedClient(0) : setSelectedClient(definedUserRole)
        setSelectedClientName("")
      } catch (error) {
        console.error('Error acquiring token:', error);
      }
    };
    

    getToken();
  }, []);

  console.log('whoIsClient', client)
  return (
    <ClientContext.Provider value={{ client, setClient, selectedClient, setSelectedClient, selectedClientName, setSelectedClientName }}>
      {children}
    </ClientContext.Provider>
  );
};

export const useClient = () => {
  const context = useContext(ClientContext);
  if (!context) {
    throw new Error('useClient must be used within an ClientProvider');
  }
  return context;
};
